export const formatMoneyAmount = (number) => {
  const config = {
    style: 'currency',
    currency: 'USD',
  };
  if (number === undefined || isNaN(number))
    number = 0;
  if(typeof number === 'string')
    number = parseFloat(number)
  return number.toLocaleString('en-US', config);
};

export const formatMoneyAmountNoDecimal = (number) => {
  if (number === undefined || isNaN(number))
    number = 0;
  if(typeof number === 'string')
    number = parseInt(number)
  const config = {
    currency: 'USD',
  };
  return number.toLocaleString('en-US', config);
};

export const formatCreditCardAndBankAccount = (typeName, lastFourNumber, paymentType = 'CC')=>{
  if (paymentType === 'ACH'){
    // For now, the type is hardcoded "Bank" because there is an inconsistency for achBankName field.
    typeName = 'Bank'
    if (lastFourNumber){
      lastFourNumber = lastFourNumber.slice(lastFourNumber.length - 4);
    }
    return `ACH ${typeName} *${lastFourNumber}`
  }else {
    return `CC ${typeName} *${lastFourNumber}`
  }
}
